<main
  id="content"
  tabindex="0"
  class="container mx-auto px-base pt-lg">
  <desy-button
    (click)="this.goBack()"
    type="button"
    classes="c-button c-button--transparent mb-3"
    html='<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 140 140" class="self-center mr-2" aria-hidden="true" focusable="false" width="1em" height="1em">
              <path d="M37.93 27.93l-35 35a10 10 0 000 14.14l35 35a10 10 0 1014.14-14.14L38.41 84.27A2.5 2.5 0 0140.18 80H130a10 10 0 000-20H40.18a2.5 2.5 0 01-1.77-4.27l13.66-13.66a10 10 0 00-14.14-14.14z" fill="currentColor"></path>
          </svg>
          Volver'></desy-button>

  <div class="mb-10">
    <desy-notification type="alert">
      <desy-title>No dispone de permisos para acceder a esta sección.</desy-title>
    </desy-notification>
  </div>
</main>
